"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _i18next = _interopRequireDefault(require("i18next"));

var _locale_en = _interopRequireDefault(require("./locale/locale_en"));

var _locale_fi = _interopRequireDefault(require("./locale/locale_fi"));

var _locale_sv = _interopRequireDefault(require("./locale/locale_sv"));

var _locale_no = _interopRequireDefault(require("./locale/locale_no"));

// import locales from './locale';
var locales = {
  en: _locale_en["default"],
  fi: _locale_fi["default"],
  sv: _locale_sv["default"],
  no: _locale_no["default"]
};
var resources = {};
Object.keys(locales).forEach(function (locale) {
  resources[locale] = {
    translation: locales[locale]
  };
});

_i18next["default"].init({
  resources: resources,
  lng: 'sv',
  keySeparator: '.',
  interpolation: {
    escapeValue: false // react already safes from xss

  }
});

var _default = _i18next["default"];
exports["default"] = _default;